import {crudStorage} from "./crudStorage";

// `isPatientAccess` was dropped: the server derives the patient-side filter from
// the session and the requested path, never from a client-asserted flag.
// See helpers/crudStorage.js.
export function viewFiles(dashState, setFiles, setSelectedFile, path, toast) {
  return crudStorage(
    dashState,
    "view",
    "",
    dashState.organization?.s3BucketName || "brightlighthealth",
    path
  )
    .then((res) => {
      setFiles(res.data || []);
      setSelectedFile("");
    })
    .catch((err) => {
      if (path.split("/").filter(Boolean).length > 1) {
        console.error(err);
      }
      setFiles([]);
    });
}
